<template>
  <div>
    <div class="flex flex_gap_10">
      <div>
        <DateRangePicker class="w_max_content" ref="range"/>
      </div>
      <multiselect
        v-model="selectedCards"
        :options="Object.values(cards)"
        :multiple="true"
        label="id"
        track-by="id"
        placeholder="Выберите карты"
        select-label="Выбрать"
        :custom-label="customLabel"
        :show-labels="false"
        deselect-label="Убрать карту">
        <!--        <template slot="singleLabel" slot-scope="props"><img class="option__image" :src="props.option.img"-->
        <!--                                                             alt="No Man’s Sky11"><span class="option__desc"><span-->
        <!--          class="option__title">{{ props.option.title }}</span></span></template>-->
        <!--        <template slot="option" slot-scope="props"><img class="option__image" :src="props.option.img"-->
        <!--                                                        alt="No Man’s Sky">-->
        <!--          <div class="option__desc"><span class="option__title">{{ props.option.title }}</span><span-->
        <!--            class="option__small">{{ props.option.desc }}</span></div>-->
        <!--        </template>-->
      </multiselect>
      <LoadingButton
        title="Показать"
        className="btn btn-outline-info"
        :onClick="() => getRecords()"
        :loading="btnLoading"
        :color="$constants.SUCCESS_COLOR"
      />
    </div>
    <div>
      <template v-if="records.length">
        <div class="flex flex_gap_5 flex-wrap mt-2">
          <span class="border p-1" v-for="(c, id) in totalExpenses">
            {{ cards[id].number.toString().slice(-4) }}: <strong
            v-for="(s,i) in c">{{ i === 0 ? '' : ', ' }}{{ $AllCurrencies[s.currency_id]?.currency }} {{
              s.total.toLocaleString('ru-RU')
            }}</strong>
          </span>
        </div>
        <table class="table table-sm table-hover mt-1">
          <tbody>
          <tr v-for="(r,i) in records">
            <td>{{ (i + 1) + ((paginator?.current_page ?? 1) - 1) * (paginator?.per_page ?? 1) }}</td>
            <td>{{ r.card.number.toString().slice(-4) }}</td>
            <td>{{ r.card.service_user?.title }}</td>
            <td>{{ r.comment }}</td>
            <td><strong>{{ r.sum }}</strong></td>
            <td>{{ $AllCurrencies[r.currency_id]?.currency }}</td>
            <td>{{ printDate(r.pass_date, 'DD.MM.YYYY') }}</td>
          </tr>
          </tbody>
        </table>
        <div class="text-right">
          <paginate v-if="paginator"
                    v-model="paginator.current_page"
                    :page-count="paginator.last_page"
                    ref="Pagination"
                    :page-range="11"
                    :margin-pages="2"
                    :click-handler="getRecords"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import api from "@/api";
// import DateRangePicker from 'vue2-daterange-picker'
import DateRangePicker from "@/components/dateSelect/DateRangePicker.vue";
import Multiselect from "vue-multiselect";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import Paginate from 'vuejs-paginate'

export default {
  components: {
    LoadingButton,
    Multiselect,
    DateRangePicker,
    Paginate,
  },
  data() {
    return {
      btnLoading: false,
      cards: {},
      selectedCards: [],
      records: [],
      totalExpenses: [],
      paginator: null,
    }
  },
  created() {
    if (!this.cards.length) this.getCards();
  },
  methods: {
    customLabel(opt) {
      return `${opt.number.toString().slice(-4)} – ${opt.service_user?.title}`
    },
    async getRecords(page = 1) {
      this.btnLoading = true;
      let {data: r_data} = await api.post('/cards/expenses', {
        action: 'list',
        page,
        cards: this.selectedCards.map(c => c.id),
        range: this.$refs.range.getRange()
      });
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.paginator = pagination;
        this.records = data;
        this.totalExpenses = r_data.totalExpenses.reduce((acc, t) => {
          if (!acc[t.card_id]) acc[t.card_id] = [];
          acc[t.card_id].push(t);
          return acc;
        }, {});
      }
      this.btnLoading = false;
    },
    async getCards() {
      const {data} = await api.index('/cards');
      if (data.success) {
        this.cards = data.records.reduce((acc, c) => {
          acc[c.id] = c;
          return acc;
        }, {});
      }
    }
  }
}

</script>

<style scoped>
.w_max_content {
  width: max-content;
}

</style>
